import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '@packages/components/protected-route/protected-route';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

import { AssetsRoutes } from './assets/assets.routes';

const AssetTagManagementPage = lazy(
  () => import('./asset-tag-management/asset-tag-management.page'),
);

export const AssetDataServiceRoutes = () => {
  const [assetsFF] = useFeatureFlag('ADS_ASSETS');
  const [fullMockedFF] = useFeatureFlag('ADS_FULL_MOCKED');
  const [assetTagsFF] = useFeatureFlag('ADS_ASSET_TAGS');
  const [gaRelease] = useFeatureFlag('ADS_GA_RELEASE');

  return (
    <ProtectedRoute
      legacyCapabilities={
        gaRelease
          ? {
              canAccessManageRisk: true,
            }
          : { assets: true }
      }
    >
      <Routes>
        {assetsFF && <Route path="/*" element={<AssetsRoutes />} />}
        {fullMockedFF && assetTagsFF && (
          <Route path="/tags" element={<AssetTagManagementPage />} />
        )}
      </Routes>
    </ProtectedRoute>
  );
};
